/*
 * Purpose: Teknoled-G company & proprietary IP — SSOT for UI and docs
 * Last modified: 2026-07-10 | Agent
 * Completeness: 100
 */
import {
  CANONICAL_API_URL,
  CANONICAL_APP_URL,
  LEGACY_MARKETING_URL,
} from '@/lib/domainConfig';

export const COMPANY_INFO = {
  legalName: 'Teknoled-G Limited',
  companyNumber: '16749208',
  companyNumberLabel: '#16749208',
  productName: 'Autoblocks.run',
  productBrand: 'Autoblocks',
  /** Official product URL — canonical for SEO, OAuth, vault, and production APP_URL */
  officialUrl: CANONICAL_APP_URL,
  /** Official API subdomain — auth, health, webhooks, admin */
  officialApiUrl: CANONICAL_API_URL,
  appUrl: CANONICAL_APP_URL,
  renderSpaUrl: 'https://autoblocks-run.onrender.com',
  renderApiUrl: 'https://autoblocks-run-api.onrender.com',
  marketingUrl: LEGACY_MARKETING_URL,
  copyrightHolder: 'Timothy R. McGuckin',
  copyrightYears: '2026',
  license: 'Proprietary — All Rights Reserved',
  repository: 'https://github.com/t1mm0/autoblocks-run',
} as const;

export const COPYRIGHT_NOTICE = `Copyright © ${COMPANY_INFO.copyrightYears} ${COMPANY_INFO.copyrightHolder}. All Rights Reserved.`;

export const COMPANY_FOOTER_LINE = `${COMPANY_INFO.legalName}, ${COMPANY_INFO.companyNumberLabel}. ${COMPANY_INFO.license}.`;
